
import React, { useState } from 'react';
import { useApollo } from '../contexts/ApolloContext';
import GET_USER_VALIDATION from '../../queries/GET_USER_VALIDATION';
import { get } from 'lodash';

const UserValidation = ({ children }) => {
  const client = useApollo();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getUserStatus = async (email) => {
    if (!email) return null;
    try {
      setLoading(true);
      setError(null);

      const filterEmail = { field: 'email', value: [email] };
      const { data } = await client.query({
        query: GET_USER_VALIDATION,
        variables: { filters: [ filterEmail ] },
        fetchPolicy: 'network-only',
      });

      var result = get(data, 'getUsersFeed.results', []);
      return  result
    } catch (err) {
      console.error('Error checking user existence:', err);
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return children({ getUserStatus, validationLoading: loading, validationError: error });
};


export default UserValidation;